(function () {
  'use strict';

  const selectors = {
    imagesContainer: '[data-images-container]',
    imageHolder: '[data-image-holder]',
    imageElement: '[data-image-element]',
    rangeButton: '[data-range-button]',
    rangeInput: '[data-range-input]',
  };

  if (!customElements.get('compare-images')) {
    customElements.define(
      'compare-images',
      class CompareImages extends HTMLElement {
        constructor() {
          super();

          this.imageHolder = this.querySelector(selectors.imageHolder);
          this.imageElement = this.querySelector(selectors.imageElement);
          this.rangeButton = this.querySelector(selectors.rangeButton);
          this.rangeInput = this.querySelector(selectors.rangeInput);
          this.containerWidth = 0;
        }

        connectedCallback() {
          this.resizeObserver = new ResizeObserver(() => this.setOverlapImageSize());
          this.resizeObserver.observe(this);

          this.rangeInput.addEventListener('input', () => this.setImagePosition());
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        setImagePosition() {
          if (!this.containerWidth) return;

          const value = this.rangeInput.value;
          const buttonWidth = this.rangeButton.offsetWidth;

          this.rangeButton.style.left = `${value}%`;
          this.imageHolder.style.width = `${((this.containerWidth - buttonWidth) * (100 - value)) / 100 + buttonWidth / 2}px`;
        }

        setOverlapImageSize() {
          const containerWidth = this.offsetWidth;
          if (!containerWidth) return;

          this.containerWidth = containerWidth;
          this.imageElement.style.width = `${containerWidth}px`;
          this.setImagePosition();
        }
      }
    );
  }

})();
//# sourceMappingURL=compare-images.js.map
